'use client';

import ClientStories from '../../home/components/ClientStories';
import Link from 'next/link';
import { motion } from 'framer-motion';

export default function AboutContent() {
  return (
    <div className="container mx-auto pl-6 pb-6 pr-6 bg-base-100">
      <div className="min-h-screen bg-base-100">
        <motion.section
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="py-8 text-center text-base-content"
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-16">
            ABOUT US
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-6 text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed font-brand"
          >
            <span className="font-bold text-primary">OMKODE</span> delivers
            <span className="font-semibold"> web & mobile development</span>,
            <span className="font-semibold"> Shopify solutions</span>,
            <span className="font-semibold"> logo design</span>,
            <span className="font-semibold"> UI/UX design</span>, and
            <span className="font-semibold"> branding</span> to help businesses
            grow.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mt-4 text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed font-brand"
          >
            Our <span className="font-semibold">web & mobile development</span>{' '}
            services focus on
            <span className="font-semibold"> scalable</span> and
            <span className="font-semibold">
              {' '}
              high-performance applications
            </span>
            , ensuring seamless user experiences.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="mt-4 text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed font-brand"
          >
            We build strong brand identities with
            <span className="font-semibold"> custom logos</span>, and
            <span className="font-semibold"> design systems </span>
            to create consistency and impact.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="mt-4 text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed font-brand"
          >
            Whether you&apos;re launching a brand, optimizing an online store,
            or refining user experiences,{' '}
            <span className="font-bold">OMKODE </span>
            provides{' '}
            <span className="font-semibold">
              custom, results-driven solutions.
            </span>
          </motion.p>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 1.0 }}
            className="mt-8"
          >
            <Link href="/our-services">
              <button className="btn btn-primary btn-lg">
                Explore Our Services
              </button>
            </Link>
          </motion.div>
        </motion.section>
        <ClientStories />
      </div>
    </div>
  );
}
